import { render, staticRenderFns } from "./NetsisFaturaAktarim.vue?vue&type=template&id=d14d9890"
import script from "./NetsisFaturaAktarim.vue?vue&type=script&lang=js"
export * from "./NetsisFaturaAktarim.vue?vue&type=script&lang=js"
import style0 from "./NetsisFaturaAktarim.vue?vue&type=style&index=0&id=d14d9890&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports